import { render, staticRenderFns } from "./updateSettings.vue?vue&type=template&id=9505c254&scoped=true"
import script from "./updateSettings.vue?vue&type=script&lang=js"
export * from "./updateSettings.vue?vue&type=script&lang=js"
import style0 from "./updateSettings.vue?vue&type=style&index=0&id=9505c254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9505c254",
  null
  
)

export default component.exports